const config = require("../config")

module.exports = {
    treePoint: {
        url: config.base_dev_url + "lz_tree/listByPoint",
        type: "post",
    },
    location: {
        url: "/ws/geocoder/v1",
        type: "get"
    },
    getAltitude: {
        url: "/v3/elevation/point",
        type: "get"
    },
    search: {
        url: "/ws/place/v1/suggestion",
        type: "get"
    },
    division: {
        url: "/ws/district/v1/list",
        type: "get"
    },
    getCtiyList: {
        url: config.base_dev_url + "poi/city",
        type: "get",
    },
    get7d: {
        url: config.base_dev_url + "lz_weather7d/get7d",
        type: "get",
    },
}
